import { useQuery } from '@tanstack/react-query';
import { getBenchmark } from '../lib/apiClient';

/** Updates once a trading day. */
export function useBenchmark() {
  return useQuery({
    queryKey: ['benchmark'],
    queryFn: getBenchmark,
    staleTime: 30 * 60_000,
  });
}
